import { CURRENCY_DATA } from 'redux/actions/currencyData';

const initialState = {
  currencies: {},
  isLoading: true,
};

export const currencyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURRENCY_DATA.STARTED:
      return { ...state, isLoading: true };
    case CURRENCY_DATA.SUCCESS:
      return { ...state, currencies: action.payload, isLoading: false };
    case CURRENCY_DATA.FAIL:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
